import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchWHGoodsIssued = createAsyncThunk(
  "api/WHGoodsIssued/fetch",
  async (
    {
      fromDate,
      toDate,
      sw_warehouse_ids = [],
      dw_warehouse_ids = [],
      exclude_sw_warehouse_ids = [],
      exclude_dw_warehouse_ids = [],
      product_ids = [],
      include_chart_vendor_receipts = false,
      group_by = "daily",
      valueType = "total",
      viewType = "all",
    },
    thunkAPI
  ) => {
    try {
      const requestData = {
        fromdate: fromDate,
        todate: toDate,
        sw_warehouse_ids,
        dw_warehouse_ids,
        exclude_sw_warehouse_ids,
        exclude_dw_warehouse_ids,
        product_ids,
        include_chart_vendor_receipts: include_chart_vendor_receipts === true,
        group_by,
        valueType,
        viewType,
      };

      const response = await api.post(`/api/WHGoodsIssued`, requestData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const WHGoodsIssuedSlice = createSlice({
  name: "WHGoodsIssued",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWHGoodsIssued.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWHGoodsIssued.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload;
      })
      .addCase(fetchWHGoodsIssued.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default WHGoodsIssuedSlice.reducer;

// Selectors
export const selectWHGoodsIssuedRows = (state) => state.WHGoodsIssued.rows;
export const selectWHGoodsIssuedStatus = (state) => state.WHGoodsIssued.status;
export const selectWHGoodsIssuedError = (state) => state.WHGoodsIssued.error;
